import React from 'react';
import MillionMarksChart from '../Charts/MillionMarksChart';

const MilestoneTab = ({ showDetails, openDrillDown }) => {
  const yearlyMilestones = [
    { id: '2019', year: '2019', date500k: 'Jun 10', daysTaken: 161, totalYearly: '1.85M', growth: '+5.2%', status: 'medium' },
    { id: '2020', year: '2020', date500k: 'Jul 5', daysTaken: 187, totalYearly: '1.65M', growth: '-10.8%', status: 'low' },
    { id: '2021', year: '2021', date500k: 'Jun 15', daysTaken: 166, totalYearly: '1.92M', growth: '+16.4%', status: 'high' },
    { id: '2022', year: '2022', date500k: 'Jun 14', daysTaken: 165, totalYearly: '2.02M', growth: '+5.1%', status: 'high' },
    { id: '2023', year: '2023', date500k: 'May 23', daysTaken: 143, totalYearly: '2.18M', growth: '+7.8%', status: 'high' }
  ];

  const getStatusClass = (status) => {
    switch(status) {
      case 'high': return 'status-indicator status-high';
      case 'medium': return 'status-indicator status-medium';
      case 'low': return 'status-indicator status-low';
      default: return 'status-indicator';
    }
  };

  const currentMilestone = {
    target: '2.5M',
    current: '1.42M',
    percentage: '56.8%',
    daysRemaining: 214,
    projectedDate: 'Dec 15, 2024'
  };

  // Handle milestone year click
  // Handle milestone year click
const handleYearClick = (milestone) => {
  if (openDrillDown) {
    openDrillDown('insight', {
      title: `${milestone.year} Milestone Analysis`,
      summary: `Performance analysis for ${milestone.year} showing ${milestone.daysTaken} days to reach 500K tons.`,
      icon: 'fas fa-trophy',
      iconColor: milestone.status === 'high' ? '#4cd964' : milestone.status === 'medium' ? '#ff9f40' : '#ff6384',
      category: 'Historical Performance',
      keyMetrics: [
        { label: 'Total Yearly', value: milestone.totalYearly, change: milestone.growth },
        { label: 'Days to 500K', value: milestone.daysTaken, change: 'vs target' },
        { label: 'Date Reached', value: milestone.date500k, change: 'Calendar day' }
      ],
      details: `Performance analysis for ${milestone.year}:`,
      quarterlyBreakdown: [
        { quarter: 'Q1', volume: `${Math.round(parseInt(milestone.totalYearly) * 0.23)}K T`, share: '23%' },
        { quarter: 'Q2', volume: `${Math.round(parseInt(milestone.totalYearly) * 0.26)}K T`, share: '26%' },
        { quarter: 'Q3', volume: `${Math.round(parseInt(milestone.totalYearly) * 0.27)}K T`, share: '27%' },
        { quarter: 'Q4', volume: `${Math.round(parseInt(milestone.totalYearly) * 0.24)}K T`, share: '24%' }
      ],
      primaryReasons: milestone.year === '2020' ? 
        ['COVID-19 impact', 'Supply chain disruptions', 'Reduced trade volumes'] :
        ['Normal operations', 'Steady growth', 'Infrastructure improvements']
    }, `${milestone.year} Milestone Analysis`);
  }
};
  // Handle KPI card click
  const handleKPIClick = (kpiType) => {
  if (openDrillDown) {
    const kpis = {
      'current-target': {
        title: 'Current Year Target Analysis',
        summary: 'Current progress toward annual target of 2.5M tons.',
        icon: 'fas fa-bullseye',
        iconColor: '#4da6ff',
        category: 'Performance Analysis',
        keyMetrics: [
          { label: 'Target', value: '2.5M', change: 'Annual' },
          { label: 'Current Progress', value: '56.8%', change: 'Achieved' },
          { label: 'Days Remaining', value: '214', change: 'Timeline' }
        ],
        details: 'Target breakdown:',
        quarterlyTargets: [
          { quarter: 'Q1', target: '550,000 T', achieved: '562,400 T', status: 'Exceeded' },
          { quarter: 'Q2', target: '600,000 T', achieved: '624,800 T', status: 'Exceeded' },
          { quarter: 'Q3', target: '650,000 T', achieved: '235,200 T', status: 'In Progress' },
          { quarter: 'Q4', target: '700,000 T', achieved: '0 T', status: 'Pending' }
        ],
        confidence: '85% probability of achievement'
      },
      'daily-rate': {
        title: 'Daily Rate Analysis',
        summary: 'Daily throughput rate analysis against target requirements.',
        icon: 'fas fa-tachometer-alt',
        iconColor: '#ff6384',
        category: 'Performance Analysis',
        keyMetrics: [
          { label: 'Required Rate', value: '5,045 T', change: 'To meet target' },
          { label: 'Current Rate', value: '6,220 T', change: '+1,175 T' },
          { label: 'Buffer Days', value: '23 days', change: 'Ahead of schedule' }
        ],
        details: 'Rate analysis:',
        primaryReasons: [
          'Required: 5,045 T/day to meet target',
          'Current: 6,220 T/day (actual)',
          'Surplus: 1,175 T/day',
          'Buffer: 23 days ahead of schedule'
        ]
      }
    };
    openDrillDown('insight', kpis[kpiType], kpis[kpiType].title);
  }
};

  return (
    <div id="milestone-tab" className="tab-content">
      <div className="insights-container">
        <div 
          className="insight-card clickable"
          onClick={() => openDrillDown && openDrillDown('500k-achievement', {
            title: '500K Tonnage Achievement',
            content: 'Port achieved 500K tons in just 143 days this year, 22 days faster than last year\'s 165 days.',
            details: 'Historical comparison:',
            years: [
              { year: '2023', days: 143, date: 'May 23' },
              { year: '2022', days: 165, date: 'Jun 14' },
              { year: '2021', days: 166, date: 'Jun 15' },
              { year: '2020', days: 187, date: 'Jul 5' }
            ],
            improvement: '15.3% faster than 5-year average'
          }, '500K Achievement')}
        >
          <div className="insight-title"><i className="fas fa-trophy"></i> 500K Tonnage Achievement</div>
          <div className="insight-content">Port achieved 500K tons in just 143 days this year, 22 days faster than last year's 165 days.</div>
        </div>
        
        <div 
          className="insight-card success clickable"
          onClick={() => openDrillDown && openDrillDown('efficiency-milestone', {
            title: 'Efficiency Milestone',
            content: 'Record turnaround time of 16.2 hours achieved for container vessels, beating previous best by 1.8 hours.',
            details: 'Efficiency improvements:',
            metrics: {
              'Previous record': '18.0 hours',
              'New record': '16.2 hours',
              'Improvement': '10.0%',
              'Industry average': '20.8 hours'
            },
            factors: ['Optimized operations', 'Advanced scheduling', 'Skilled workforce']
          }, 'Efficiency Milestone')}
        >
          <div className="insight-title"><i className="fas fa-bolt"></i> Efficiency Milestone</div>
          <div className="insight-content">Record turnaround time of 16.2 hours achieved for container vessels, beating previous best by 1.8 hours.</div>
        </div>
        
        <div 
          className="insight-card warning clickable"
          onClick={() => openDrillDown && openDrillDown('seasonal-variation', {
            title: 'Seasonal Variation Analysis',
            content: 'Q1 typically sees slower milestone achievement due to weather conditions and holiday periods.',
            details: 'Seasonal pattern:',
            pattern: [
              { quarter: 'Q1', speed: 'Slowest', factors: ['Weather', 'Holidays', 'Maintenance'] },
              { quarter: 'Q2', speed: 'Improving', factors: ['Better weather', 'Post-holiday recovery'] },
              { quarter: 'Q3', speed: 'Peak', factors: ['Optimal conditions', 'High demand'] },
              { quarter: 'Q4', speed: 'Strong', factors: ['Year-end rush', 'Inventory buildup'] }
            ],
            planning: 'Adjust targets based on seasonal patterns'
          }, 'Seasonal Analysis')}
        >
          <div className="insight-title"><i className="fas fa-calendar-alt"></i> Seasonal Variation</div>
          <div className="insight-content">Q1 typically sees slower milestone achievement due to weather conditions and holiday periods.</div>
        </div>
      </div>
      
      <div className="info-container">
        <h3 className="section-title">
          <i className="fas fa-trophy"></i>
          <span>Million Mark Performance (Last 5 Years)</span>
        </h3>
        
        <div className="charts-section">
          <div className="chart-container">
            <MillionMarksChart 
              onClick={() => openDrillDown && openDrillDown('million-marks', {
                title: 'Million Marks Performance',
                period: '2019-2023',
                trend: 'Steady improvement',
                highlights: [
                  'Best year: 2023 (143 days to 500K)',
                  'COVID impact: 2020 slowest',
                  'Recovery: Strong bounce back in 2021'
                ],
                forecast: '2024 expected to break record'
              }, 'Million Marks Analysis')}
            />
          </div>
          
          <div className="table-container">
            <h4>Yearly Milestone Achievement</h4>
            <table className="data-table">
              <thead>
                <tr>
                  <th>Year</th>
                  <th>500K Date</th>
                  <th>Days Taken</th>
                  <th>Total Yearly</th>
                  <th>Growth</th>
                </tr>
              </thead>
              <tbody>
                {yearlyMilestones.map((milestone, index) => (
                  <tr 
                    key={index} 
                    className={index === 4 ? 'highlight clickable-row' : 'clickable-row'}
                    onClick={() => handleYearClick(milestone)}
                  >
                    <td><strong>{milestone.year}</strong></td>
                    <td>{milestone.date500k}</td>
                    <td>{milestone.daysTaken}</td>
                    <td>{milestone.totalYearly}</td>
                    <td><span className={getStatusClass(milestone.status)}>{milestone.growth}</span></td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>

      <div className="dashboard-cards" style={{marginTop: '30px'}}>
        <div 
          className="card clickable"
          onClick={() => handleKPIClick('current-target')}
        >
          <div className="card-header">
            <div className="card-title">Current Year Target</div>
            <div className="card-icon" style={{backgroundColor: '#4da6ff'}}>
              <i className="fas fa-bullseye"></i>
            </div>
          </div>
          <div className="card-content">
            <div className="card-value">{currentMilestone.target}</div>
            <div className="progress-bar">
              <div className="progress-fill" style={{width: currentMilestone.percentage, backgroundColor: '#4da6ff'}}></div>
            </div>
            <div className="card-change positive" style={{marginTop: '10px'}}>
              <i className="fas fa-chart-line"></i>
              <span>{currentMilestone.percentage} achieved</span>
            </div>
          </div>
        </div>
        
        <div 
          className="card clickable"
          onClick={() => openDrillDown && openDrillDown('current-volume', {
            title: 'Current Volume Analysis',
            value: '1.42M',
            icon: 'fas fa-weight-hanging',
            color: '#4cd964',
            details: 'Volume breakdown:',
            q1: '562,400 T (39.6%)',
            q2: '624,800 T (44.0%)',
            q3: '235,200 T (16.4%)',
            q4: '0 T (0%)',
            status: 'Ahead of schedule by 12 days'
          }, 'Current Volume')}
        >
          <div className="card-header">
            <div className="card-title">Current Volume</div>
            <div className="card-icon" style={{backgroundColor: '#4cd964'}}>
              <i className="fas fa-weight-hanging"></i>
            </div>
          </div>
          <div className="card-content">
            <div className="card-value">{currentMilestone.current}</div>
            <div className="card-change positive">
              <i className="fas fa-arrow-up"></i>
              <span>Ahead of schedule by 12 days</span>
            </div>
          </div>
        </div>
        
        <div 
          className="card clickable"
          onClick={() => openDrillDown && openDrillDown('days-remaining', {
            title: 'Days Remaining Analysis',
            value: '214',
            icon: 'fas fa-calendar-day',
            color: '#ff9f40',
            details: 'Timeline analysis:',
            daysElapsed: '151 days',
            daysRemaining: '214 days',
            projectedCompletion: 'Dec 15, 2024',
            confidence: '85% probability'
          }, 'Timeline Analysis')}
        >
          <div className="card-header">
            <div className="card-title">Days Remaining</div>
            <div className="card-icon" style={{backgroundColor: '#ff9f40'}}>
              <i className="fas fa-calendar-day"></i>
            </div>
          </div>
          <div className="card-content">
            <div className="card-value">{currentMilestone.daysRemaining}</div>
            <div className="card-change positive">
              <i className="fas fa-clock"></i>
              <span>Projected completion: {currentMilestone.projectedDate}</span>
            </div>
          </div>
        </div>
        
        <div 
          className="card clickable"
          onClick={() => handleKPIClick('daily-rate')}
        >
          <div className="card-header">
            <div className="card-title">Daily Rate Required</div>
            <div className="card-icon" style={{backgroundColor: '#ff6384'}}>
              <i className="fas fa-tachometer-alt"></i>
            </div>
          </div>
          <div className="card-content">
            <div className="card-value">5,045 T</div>
            <div className="card-change positive">
              <i className="fas fa-check-circle"></i>
              <span>Current daily rate: 6,220 T</span>
            </div>
          </div>
        </div>
      </div>

      <div className="table-container" style={{marginTop: '30px'}}>
        <h3 className="section-title">
          <i className="fas fa-flag-checkered"></i>
          <span>Quarterly Milestone Progress</span>
        </h3>
        <table className="data-table">
          <thead>
            <tr>
              <th>Quarter</th>
              <th>Target</th>
              <th>Achieved</th>
              <th>Progress</th>
              <th>Status</th>
            </tr>
          </thead>
          <tbody>
            <tr 
              className="clickable-row"
              onClick={() => openDrillDown && openDrillDown('q1-progress', {
                title: 'Q1 2024 Progress',
                target: '550,000 T',
                achieved: '562,400 T',
                progress: '102.3%',
                status: 'Exceeded',
                details: 'Q1 performance:',
                monthlyBreakdown: [
                  { month: 'Jan', target: '180,000 T', achieved: '185,200 T' },
                  { month: 'Feb', target: '175,000 T', achieved: '178,500 T' },
                  { month: 'Mar', target: '195,000 T', achieved: '198,700 T' }
                ],
                factors: ['Strong start', 'Favorable weather', 'High demand']
              }, 'Q1 Progress')}
            >
              <td><strong>Q1 2024</strong></td>
              <td>550,000 T</td>
              <td>562,400 T</td>
              <td>102.3%</td>
              <td><span className="status-indicator status-high">Exceeded</span></td>
            </tr>
            {/* ... other rows with similar click handlers ... */}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default MilestoneTab;